<template>
  <div v-if="activity.notes.length || always_visible" class="activity-notes-button d-inline">
    <f7-icon f7="square_pencil" tooltip="Notities"
             :color="activity.notes.length > 0 ? 'blue' : ''"
             @click.prevent.stop.self="onShowActivityNotes"
    ></f7-icon>
    <activity-notes-sheet-modal
      :show="showActivityNotes"
      @closed="showActivityNotes = false"

      :activity="activity"
      :training_session="training_session"
    ></activity-notes-sheet-modal>
  </div>
</template>

<script>
  import ActivityNotesSheetModal from "./ActivityNotesSheetModal.vue";

  export default {
    components: {
      ActivityNotesSheetModal
    },

    props:{
      activity: {},
      always_visible: {default: false}
    },

    mixins: [],

    data: function () {
      return {
        showActivityNotes: false,
      };
    },

    computed: {
      training_session() {
        return this.$store.getters['training_sessions/find'](this.activity.training_session_id);
      },
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      onShowActivityNotes() {
        this.showActivityNotes = true;
      }
    },

    watch: {
      //
    }
  };
</script>
